"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_SEGMENT_SCRIPT = exports.LIST_SEGMENT_SCRIPTS = void 0;
const react_1 = __importDefault(require("react"));
const auth_1 = require("common/auth");
const models_hook_1 = require("app/models.hook");
const route_1 = require("../route");
const ScriptList_1 = require("./ScriptList");
require("./style.scss");
exports.LIST_SEGMENT_SCRIPTS = route_1.SEGMENT_SCRIPTS.sub("/list", Scripts);
exports.UPDATE_SEGMENT_SCRIPT = route_1.SEGMENT_SCRIPT.sub("/edit", Scripts);
function Scripts({ projectId, scriptId, segmentId, }) {
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const scriptDoc = (0, models_hook_1.useScriptDoc)({
        segmentId,
        projectId,
        scriptId,
    });
    return (react_1.default.createElement(ScriptList_1.ScriptList, { projectId: projectId, scriptId: scriptId, scriptDoc: scriptDoc, segmentId: segmentId }));
}
exports.default = Scripts;
